// TODO FLOW-TO-TS For some reason, adding the correct type annotation to getComponent breaks Promise.all here
// export function lazyRender(domSelector: any, getComponent: () => Promise<React.ComponentType>) {

// @ts-ignore
export function lazyRender(domSelector, getComponent) {
  // Element may not be present on page.
  const targets = document.querySelectorAll(domSelector);

  if (targets.length) {
    Promise.all([import('react'), import('react-dom'), getComponent()]).then(
      ([{createElement}, {render}, Component]) => {
        Array.from(targets).forEach(target => {
          const props = JSON.parse(target.getAttribute('data-props') || '{}');

          render(createElement(Component, props), target);
        });
      }
    );
  }
}
